module.exports = ":host {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/row-pinning/row-pinning.component.css
// module id = ./src/app/examples/row-pinning/row-pinning.component.css
// module chunks = main